import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo } from 'react';

import { L } from '@lib';

const { Option } = Select;

interface IProps {
  value?: number;
  onChange?: ((value: number, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const InvoiceDueDateSelect: React.FC<IProps> = memo(({ value, onChange }) => {
  return (
    <Select size="small" defaultValue={0} value={value} onChange={onChange}>
      <Option value={0}>{L('Now')} </Option>
      <Option value={30}>{L('30')}</Option>
      <Option value={60}>{L('60')}</Option>
      <Option value={90}>{L('90')}</Option>
    </Select>
  );
});
